export const BASEURL = ''


//////////////////
// WEBPACK FOOTER
// ./static/js/api.js
// module id = null
// module chunks = 